// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './vuex'
import App from './App'
import router from './router'
import axios from 'axios'
import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'es6-promise/auto'
import echarts from 'echarts'
import Share from 'vue-social-share'
import 'swiper/dist/idangerous.swiper.css'
import 'vue-social-share/dist/client.css'
import 'babel-polyfill'
import Print from 'vue-print-nb'
Vue.use(Print)
Vue.use(Share)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.config.silent = process.env.silent
// console.log(process.env)
Vue.prototype.$axios = axios
var base = '/swfgk'
// var base = '.'
Vue.prototype.$echarts = echarts
Vue.prototype.base = base
export default {
  base
}
axios.defaults.withCredentials = true
if (location.hash == '#/' || location.hash == 'index.html#/') {
  location.hash = '#/home/welcome'
}
axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('userinfo')) {
      config.headers.token = JSON.parse(localStorage.getItem('userinfo')).msg
      config.headers.Authorization = config.headers.token
    }
    return config
  },
  error => {
    alert(error)
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    if(location.href.indexOf("/home/login") != -1) {
      store.commit('thirdLogin', true)
    }
    if (response.data.code == 'SW401' || response.data.code == 'SW403') {
      // if (location.href.indexOf("/home/welcome") == -1 && location.href.indexOf("/home/register") == -1) {
      // open("您还未登录", "", "error", false, false);
      store.commit('notLogin', response.data.code)
      // localStorage.setItem("notLogin", true);
      // router.push({
      // 	path: "/home/welcome"
      // });

      // }
    } else {
      return response
    }
  },
  error => {
    return Promise.reject(error.response) // 返回接口返回的错误信息
  }
)

axios({
  method: 'post',
  url: `${base}/user/loginJudge`
}).then(data => {
  var data = data.data;
  if (!data) {
    if(store.state.thirdLogin) {
      store.commit('notLogin', 'thirdNotLogin')
    }else {
      store.commit('notLogin', 'SW401Notopen')
    }
  }
})

if (localStorage.getItem('userinfo') != null && location.href.indexOf('welcome') == -1) {
  if(location.href.indexOf('/come') != -1 || location.href.indexOf('/thirdDetail') != -1) {
    axios({
      url: base + `/home/showSy`
    }).then(data => {
      var data = data.data
      store.commit('list', data)
    })
  }else {
    axios({
      url: base + `/auth/isAdmin`
    }).then(data => {
      if(data != undefined) {
        var data = data.data
        store.commit('isAdmin', data)
      }
    })

    axios({
      url: base + `/home/showSy`
    }).then(data => {
      var data = data.data
      store.commit('list', data)
    })
  }

}
// console.log(document.body.clientWidth)
// console.log(window.screen.availWidth)
// console.log(document.body.scrollWidth)
if (window.screen.availWidth < 700) {
  document.getElementsByTagName('body')[0].style.width = '1440px'
  store.commit('isPhone', true)
} else {
  // document.getElementsByTagName("body")[0].style.width  = window.screen.availWidth+"px";
  store.commit('isPhone', false)
}

Vue.filter('datePicker', function(value) {
  // console.log(value)
  if (!value || value == '') return ''
  const dataValue = new Date(value)
  var month = parseInt(dataValue.getMonth()) + 1
  if (month < 10) {
    month = '0' + month
  }
  var date = dataValue.getDate()
  if (date < 10) {
    date = '0' + date
  }
  return dataValue.getFullYear() + '-' + month + '-' + date
})
/* Vue.filter('dateformat', function() {
  return function(date, format) {
      if (date) {
          if (format) {
              return moment(date).format(format);
          } else {
              return moment(date).calendar();
          }
      }
      return '';
  };
}); */
Vue.filter('undefinedFilter', function(value) {
  if (!value || value == '') {
    value = ''
  };
  return value
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js